import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Backs the merchant file exchange SFTP identity provider: the SFTP username
 * is the team id and the password is the public API bearer token.
 */
export const verifyFileExchangeAccess = {
  name: "verifyFileExchangeAccess" as const,
  input: z.object({ teamId: zExt.objectId(), bearerToken: z.string() }),
  output: z.object({ authorized: z.boolean() }),
};
